/* eslint-disable jira/choreographer/message-id-by-folder-structure */
/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import type { MaybeChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';
import {
	JiraModal as AKModalDialog,
	type JiraModalProps,
} from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useModalDialogActions, useReturnFocusTo } from './useModalDialogActions.tsx';

export const ModalDialog = ({
	shouldReturnFocus,
	...rest
}: JiraModalProps & MaybeChoreographedComponentProps): React.JSX.Element => {
	const returnFocusTarget = useReturnFocusTo();
	const { setReturnFocusTo } = useModalDialogActions();

	useEffect(
		() => () => {
			if (returnFocusTarget?.current) {
				if (
					!shouldReturnFocus &&
					expVal('jjj-board-and-backlog-a11y-focus-management-fixes', 'isEnabled', false)
				) {
					// Defer past react-focus-lock cleanup, which fires synchronously on unmount
					// and overrides an immediate .focus() call by returning focus to document.body
					const targetEl = returnFocusTarget.current;
					setTimeout(() => {
						targetEl.focus();
					}, 0);
				} else if (!shouldReturnFocus) {
					returnFocusTarget.current.focus();
				}
				setReturnFocusTo(null);
			}
		},
		[returnFocusTarget, setReturnFocusTo, shouldReturnFocus],
	);

	/**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */
	const returnFocus = shouldReturnFocus ?? !returnFocusTarget;

	return (
		<AKModalDialog
			shouldReturnFocus={returnFocus}
			{...rest}
			messageId={rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog'}
			messageType={rest.messageType ?? 'transactional'}
		/>
	);
};
